import classNames from "classnames";

export interface ILoadingDotsProps {
    className?: string;
}

export function LoadingDots({className}: ILoadingDotsProps) {
    return (
        <div className={classNames("absolute left-1/2 top-1/3 transform -translate-x-1/2 -translate-y-1/4", className)}>
            <div className="loader flex items-center justify-center space-x-1 animate-bounce h-8 deplay-800">
                <div className="w-1.5 h-1.5 bg-white rounded-full" />
                <div className="w-1.5 h-1.5 bg-white rounded-full" />
                <div className="w-1.5 h-1.5 bg-white rounded-full" />
            </div>
        </div>
    );
}
